import { Paper, getContrastColor, useMantineTheme } from "@mantine/core"
import { CalendarAppointment } from "../../../../@client/Theasoft_ApiServer_Calendar"
import { PropsWithChildren } from "react"
import { useColorScheme } from "@mantine/hooks"
// import {
//   eStatusStatus_AllValues,
//   eStatusStatus
// } from "../../../../@client/Theasoft_DataTypes_Enums"
// import { getStripedGradientRuleFromColor } from "../../../../utils/getStripedGradientRule"

interface Props extends PropsWithChildren {
  appointment: CalendarAppointment
}

export function CalendarAppointmentPaper({ appointment, children }: Props) {
  const theme = useMantineTheme()

  const scheme = useColorScheme()

  // const statusIndex =
  //   appointment.source === "PersonStatus"
  //     ? eStatusStatus_AllValues.indexOf(appointment.status as eStatusStatus)
  //     : -1

  const background =
    // appointment.isLikeRequest
    // ? getStripedGradientRuleFromColor(
    //     appointment.backColorHEX,
    //     `${appointment.backColorHEX}7F`,
    //     10
    //   )
    // :
    appointment.backColorHEX ?? undefined

  const c = appointment.backColorHEX
    ? (appointment.foreColorHEX ??
      getContrastColor({ color: appointment.backColorHEX, theme }))
    : appointment.foreColorHEX
      ? (scheme === "dark" && appointment.foreColorHEX === "#000000") ||
        (scheme === "light" && appointment.foreColorHEX === "#FFFFFF")
        ? undefined
        : appointment.foreColorHEX
      : undefined

  return (
    <Paper miw="10rem" withBorder bg={background ?? undefined} p="xs" c={c}>
      {children}
    </Paper>
  )
}
